// MessageId.jsx
import React from 'react';
import { useLoaderData } from 'react-router';

import MetaTagsHelmet from '../component/MetaTagsHelmet.jsx';
import MongoObjectIdMatcher from '../component/MongoObjectIdMatcher.jsx';
import UniversalContainer from '../component/UniversalContainer.jsx';
import { EMPTY_ARRAY } from '../resource/defaults.js';
import { reactRouterNoindexLoader } from '../resource/reactRouterNoindexLoader.js';

export const loader = reactRouterNoindexLoader;

const MessageIdRoute = () => {
  const { meta = EMPTY_ARRAY } = useLoaderData();

  return (
    <>
      <MetaTagsHelmet metaTags={meta} />
      <MongoObjectIdMatcher paramKeys={['messageId']}>
        <UniversalContainer filename="StoryMessage" shouldLoop={true} />
      </MongoObjectIdMatcher>
    </>
  );
};

export default MessageIdRoute;
